// extracted by mini-css-extract-plugin
export var background = "_87-6";
export var containerMedium = "_87-0";
export var containerMicro = "_87-2";
export var containerSmall = "_87-1";
export var dropdown = "_87-5";
export var dropdownLabel = "_87-a";
export var enter = "_87-7";
export var exitActive = "_87-8";
export var label = "_87-3";
export var option = "_87-9";
export var select = "_87-4";